import { createTransform } from 'redux-persist';
import type cartReducer from '@/features/cart/cartSlice';

type CartState = ReturnType<typeof cartReducer>;

// SC-1243: ask again after EVERY reload, including current-version storage and
// carts with items. Keep the mode for checkout/payment return and cart pricing;
// only the explicit confirmation is transient. A version migration runs once
// and cannot enforce this lifetime.
const withoutModeConfirmation = (cart: CartState): CartState => ({
  ...cart,
  modeConfirmedByRestaurant: {},
});

export const cartPersistence = createTransform(
  withoutModeConfirmation,
  withoutModeConfirmation,
  { whitelist: ['cart'] },
);
